import { useMemo } from 'react';
import { SmartPolicyEntityFullData } from '../../../SmartPoliciesTypes';
import { useSmartPolicyContext } from '../../../SmartPolicyContext';
import ScopeComponent from './ScopeComponent/ScopeComponent';
import { AD_ENTITY_TYPES, ScopeEntity, SCOPES } from './ScopeComponent/ScopeTypes';
import useHasPermissions from '../../../../../../../../hooks/useHasPermissions';
import { Pages, Roles } from '../../../../../../../../context/contexts/UserContext/permissionsTypes';

const InScope = () => {
    const { smartPolicyForEdit, setSmartPolicyForEdit } = useSmartPolicyContext();
    const isEditor = useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.EDITOR });
    const inScopeEntities = useMemo(() => {
        return (smartPolicyForEdit?.entities || [])
            .filter((entity) => !entity.excluded)
            .map((entity) => ({
                guid: entity.guid,
                display_name: entity.display_name,
                domain_name: entity.domain_name,
                type: entity.type as AD_ENTITY_TYPES
            })) as ScopeEntity[];
    }, [smartPolicyForEdit?.entities]);

    if (!smartPolicyForEdit) {
        return <></>;
    }

    const onChange = (entities: ScopeEntity[]) => {
        const smartPolicyInScopeEntities: SmartPolicyEntityFullData[] = entities.map((entity) => ({
            guid: entity.guid,
            display_name: entity.display_name,
            domain_name: entity.domain_name,
            type: entity.type,
            excluded: false
        }));
        const outScopeEntities: SmartPolicyEntityFullData[] = smartPolicyForEdit.entities.filter(
            (entity) => entity.excluded
        );

        setSmartPolicyForEdit({
            ...smartPolicyForEdit,
            entities: [...smartPolicyInScopeEntities, ...outScopeEntities]
        });
    };

    return (
        <ScopeComponent
            entities={inScopeEntities}
            onChange={onChange}
            scope={SCOPES.IN_SCOPE}
            mandatory={true}
            disabled={!isEditor}
        />
    );
};

export default InScope;
